import { priceOptions } from '../../options/options';
import {
  IKeyThemeForField,
  IKeyThemeOption,
} from '../../ui/interfaces/IFilterFormProps';

export const parsedValuePrice = (value: string) => {
  return value ? JSON.parse(value) : null;
};

export const selectedOptionPrice = (value: string) => {
  const newParsedValue = parsedValuePrice(value);

  return priceOptions.find(
    option =>
      option.value.min === newParsedValue?.min &&
      option.value.max === newParsedValue?.max,
  );
};

export const isValueExist = (value: number) =>
  value !== null && value !== undefined && !Number.isNaN(value);

export const getKeyThemesOptionsByCategory = (
  keyThemesList: IKeyThemeOption[],
): IKeyThemeForField[] => {
  return keyThemesList?.reduce((acc: IKeyThemeForField[], keyThemeItem) => {
    // Проверяется, есть ли уже в списке такой элемент категории
    const isValueExist = acc.find(
      theme => theme.label === keyThemeItem.categoryName,
    );
    if (!isValueExist) {
      // Если объект с такой категорией НЕ СУЩЕСТВУЕТ, то он добавлется со своей опцией
      return [
        ...acc,
        {
          label: keyThemeItem.categoryName,
          title: keyThemeItem.categoryName,
          options: [
            {
              label: keyThemeItem.label,
              value: keyThemeItem.value,
            },
          ],
        },
      ];
    } else {
      // Если объект с такой категорией СУЩЕСТВУЕТ, то обновляется только список его опций
      return acc.map(subElement =>
        subElement.label === keyThemeItem.categoryName
          ? {
              ...subElement,
              options: [
                ...subElement.options,
                {
                  label: keyThemeItem.label,
                  value: keyThemeItem.value,
                },
              ],
            }
          : subElement,
      );
    }
  }, []);
};
